import { render, staticRenderFns } from "./activityLogs.vue?vue&type=template&id=910164ee&scoped=true"
import script from "./activityLogs.vue?vue&type=script&lang=ts"
export * from "./activityLogs.vue?vue&type=script&lang=ts"
import style0 from "./activityLogs.vue?vue&type=style&index=0&id=910164ee&prod&scoped=true&lang=scss"
import style1 from "./activityLogs.vue?vue&type=style&index=1&id=910164ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910164ee",
  null
  
)

export default component.exports